// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

.loadingIndicator {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 1100;
}

.dashboard-body {
  background-color: #fafafa;
}

.dashboard-content {
  padding: 2rem;
  padding-top: 3.5rem;
}

.no-padding {
  padding: 0;
}

h1 {
  padding-top: 0.45rem !important;
}

.note-component:hover {
  background-color: #f8f8f8;
  cursor: pointer;
}

.note-component:hover>td>div>span {
  text-decoration: underline;
}

.entity-component:hover {
  background-color: #f8f8f8;
  cursor: pointer;
}

.entity-component:hover>td:first-child {
  text-decoration: underline;
}

.interal-field-width {
  min-width: 75px;
}

.button-margin {
  margin: 3px;
}

div.errorNotification {
  top: 0;
}

div.errorNotification>div {
  background-color: #d42828;
}

.hidden {
  display: none !important;
}

.iconStyle {
  background-color: transparent !important;
  border: 0 !important;
}

#appLoadingStatus {
  position: absolute;
  top: 50%;
  left: 50%;
}

.logoutBody {
  background-image: url("https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png");
  background-size: cover;
}

.loginBody {
  min-height: calc(100vh - 4.36rem);
  background-image: url("https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png");
  background-size: cover;
}

@media (max-width: 350px) {
  .loginBody {
    min-height: calc(100vh - 7rem);
  }
}

@media (max-width: 638px) {
  .loginBody {
    min-height: calc(100vh - 5.672rem);
  }
}

footer {
  height: auto !important;
  width: 100%;
  bottom: 0;
  border-top: 0.0625rem solid #ccc;
  border-bottom: 0rem !important;
  background-color: #fafafa !important;
  padding: 1.5rem !important;
}

header li:focus {
  background-color: rgba(0, 0, 0, 0.08) !important;
}

header {
  margin-right: 0rem !important;
}

.eds-header-bar-logo {
  outline: none !important;
}

.section-link:focus {
  outline: none !important;
  box-shadow: inset 0 0 0 0.125rem #51abff;
}

.fade {
  transition: all 1s ease-in-out;
  opacity: 0;
  display: none;
}

button.fab {
  position: static;
  bottom: 1rem;
  right: 0.5rem;
}

@media (min-width: 849px) {
  button.fab {
    top: 5.5rem;
  }

  .studentDataCriteria_Dropdown1 {
    max-width: 450px;
  }

  .studentDataCriteria_Dropdown2 {
    max-width: 434px;
  }
}

/*
    Medium devices on wards.
  */

@media (min-width: 601px) {
  .hide-tablet {
    display: none !important;
  }

  .criteria_Button {
    min-width: 12.5rem !important;
    margin-top: 0.5rem !important;
  }

  .sqlCriteriaText {
    width: 65% !important;
  }

  .questionContainer {
    margin-left: 1rem;
  }

  #ReportCriteria_RadioGroup>label>span {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
    margin-left: 0rem;
  }

  .reportFilter {
    width: 70%;
    text-align: initial;
  }

  .studentDataCriteria_Dropdown1 {
    max-width: 335px;
  }

  .studentDataCriteria_Dropdown2 {
    max-width: 311px;
    width: 100% !important;
  }
}

/*
    Smaller devices.
  */

@media (max-width: 767px) {
  .hide-mobile {
    display: none !important;
    background-color: transparent;
    border: 0 !important;
  }

  .react-time-picker__inputGroup {
    padding: unset !important;
    position: relative;
    top: 0.375rem;
    left: 1rem;
  }
}

@media (max-width: 600px) {
  #LoginForm_Card {
    margin-top: 0rem !important;
  }

  #TransitTabs_Tabs {
    display: none;
  }

  #TransitTabs_TabsTitle {
    margin-bottom: 0;
  }

  #TransitTabs_Container {
    margin: 0.5rem;
  }

  #TransitTabs_Card {
    padding: 0rem;
  }

  #TransitTabs_TabContents {
    margin: 0rem;
    margin-top: 2rem !important;
  }

  #ReportSelector_Dropdown {
    margin: auto;
  }

  #ReportSelector_Card {
    padding: 1rem;
  }

  #ReportManager_Card {
    padding: 0rem;
    overflow-x: auto;
    margin-top: 1rem;
    padding: 1rem;
  }

  .hide-mobile {
    display: none !important;
  }

  .tabsContainer {
    margin: 0.5rem;
  }

  .tabContents {
    margin: 0.5rem;
  }

  .stepLabel {
    margin-left: 1rem;
  }

  .reportFilter {
    margin-top: 1rem !important;
    width: 84% !important;
    text-align: initial;
  }

  .reportFilterTypography {
    margin-top: 1rem !important;
  }

  #ReportSelector_FormControl {
    margin: 0rem !important;
  }

  #ReportSelector_Intro {
    margin-bottom: 0rem;
  }

  .cardPadding {
    padding: 0rem;
    overflow-x: auto;
  }

  .stepProgress {
    margin-top: 1rem;
  }

  #ReportSteps_StepProgress {
    margin-top: 2rem;
  }

  #StudentCriteria_GridStudentIdField {
    margin-left: 0rem;
    width: 98%;
  }

  #StudentCriteria_TextField {
    margin-left: 0rem !important;
  }

  #StudentCriteria_Table>thead>tr>th>span {
    font-size: 0.875rem;
  }

  .criteria_Button {
    margin-top: 0.5rem !important;
    margin-left: 0rem !important;
  }

  #ReportCriteria_RadioGroup>label>span {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
    margin-left: 0rem;
  }

  #ReportCriteria_Continue {
    margin-left: 1rem;
    width: 95%;
  }

  .studentDataCriteria_Dropdown1 {
    max-width: 305px;
  }

  .studentDataCriteria_Dropdown2 {
    max-width: 256px;
  }

  #recurrence-information-popover>div {
    left: 30px !important;
  }
}

/* Override material-ui OutlinedInput dropdown which we can't figure out how to get to through PaperProps, like in What-If */

ul {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* here be hacks, cap'n. */
.compare-control-dropdown div[role="button"] {
  padding-right: 0;
}

.compare-control-dropdown div {
  font-size: 0.85rem;
}

.compare-control-dropdown svg {
  width: 0.85em;
  height: 0.85em;
}

#LoginForm_username-label[data-shrink="true"] {
  width: auto !important;
}

#LoginForm_password-label[data-shrink="true"] {
  width: auto !important;
}

#transit_freeText-label {
  font-size: 0.95rem !important;
}

.react-time-picker__wrapper {
  background-color: transparent !important;
  min-width: unset !important;
}

label {
  max-width: calc(100% - 3rem) !important;
}`, "",{"version":3,"sources":["webpack://./src/style/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,+GAA+G;EAC/G,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,+GAA+G;EAC/G,sBAAsB;AACxB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;GAEG;;AAEH;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;;GAEG;;AAEH;EACE;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,4HAA4H;;AAE5H;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":["html {\n  height: 100%;\n}\n\n.loadingIndicator {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  z-index: 1100;\n}\n\n.dashboard-body {\n  background-color: #fafafa;\n}\n\n.dashboard-content {\n  padding: 2rem;\n  padding-top: 3.5rem;\n}\n\n.no-padding {\n  padding: 0;\n}\n\nh1 {\n  padding-top: 0.45rem !important;\n}\n\n.note-component:hover {\n  background-color: #f8f8f8;\n  cursor: pointer;\n}\n\n.note-component:hover>td>div>span {\n  text-decoration: underline;\n}\n\n.entity-component:hover {\n  background-color: #f8f8f8;\n  cursor: pointer;\n}\n\n.entity-component:hover>td:first-child {\n  text-decoration: underline;\n}\n\n.interal-field-width {\n  min-width: 75px;\n}\n\n.button-margin {\n  margin: 3px;\n}\n\ndiv.errorNotification {\n  top: 0;\n}\n\ndiv.errorNotification>div {\n  background-color: #d42828;\n}\n\n.hidden {\n  display: none !important;\n}\n\n.iconStyle {\n  background-color: transparent !important;\n  border: 0 !important;\n}\n\n#appLoadingStatus {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.logoutBody {\n  background-image: url(\"https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png\");\n  background-size: cover;\n}\n\n.loginBody {\n  min-height: calc(100vh - 4.36rem);\n  background-image: url(\"https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png\");\n  background-size: cover;\n}\n\n@media (max-width: 350px) {\n  .loginBody {\n    min-height: calc(100vh - 7rem);\n  }\n}\n\n@media (max-width: 638px) {\n  .loginBody {\n    min-height: calc(100vh - 5.672rem);\n  }\n}\n\nfooter {\n  height: auto !important;\n  width: 100%;\n  bottom: 0;\n  border-top: 0.0625rem solid #ccc;\n  border-bottom: 0rem !important;\n  background-color: #fafafa !important;\n  padding: 1.5rem !important;\n}\n\nheader li:focus {\n  background-color: rgba(0, 0, 0, 0.08) !important;\n}\n\nheader {\n  margin-right: 0rem !important;\n}\n\n.eds-header-bar-logo {\n  outline: none !important;\n}\n\n.section-link:focus {\n  outline: none !important;\n  box-shadow: inset 0 0 0 0.125rem #51abff;\n}\n\n.fade {\n  transition: all 1s ease-in-out;\n  opacity: 0;\n  display: none;\n}\n\nbutton.fab {\n  position: static;\n  bottom: 1rem;\n  right: 0.5rem;\n}\n\n@media (min-width: 849px) {\n  button.fab {\n    top: 5.5rem;\n  }\n\n  .studentDataCriteria_Dropdown1 {\n    max-width: 450px;\n  }\n\n  .studentDataCriteria_Dropdown2 {\n    max-width: 434px;\n  }\n}\n\n/*\n    Medium devices on wards.\n  */\n\n@media (min-width: 601px) {\n  .hide-tablet {\n    display: none !important;\n  }\n\n  .criteria_Button {\n    min-width: 12.5rem !important;\n    margin-top: 0.5rem !important;\n  }\n\n  .sqlCriteriaText {\n    width: 65% !important;\n  }\n\n  .questionContainer {\n    margin-left: 1rem;\n  }\n\n  #ReportCriteria_RadioGroup>label>span {\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem;\n    margin-right: 0.5rem;\n    margin-left: 0rem;\n  }\n\n  .reportFilter {\n    width: 70%;\n    text-align: initial;\n  }\n\n  .studentDataCriteria_Dropdown1 {\n    max-width: 335px;\n  }\n\n  .studentDataCriteria_Dropdown2 {\n    max-width: 311px;\n    width: 100% !important;\n  }\n}\n\n/*\n    Smaller devices.\n  */\n\n@media (max-width: 767px) {\n  .hide-mobile {\n    display: none !important;\n    background-color: transparent;\n    border: 0 !important;\n  }\n\n  .react-time-picker__inputGroup {\n    padding: unset !important;\n    position: relative;\n    top: 0.375rem;\n    left: 1rem;\n  }\n}\n\n@media (max-width: 600px) {\n  #LoginForm_Card {\n    margin-top: 0rem !important;\n  }\n\n  #TransitTabs_Tabs {\n    display: none;\n  }\n\n  #TransitTabs_TabsTitle {\n    margin-bottom: 0;\n  }\n\n  #TransitTabs_Container {\n    margin: 0.5rem;\n  }\n\n  #TransitTabs_Card {\n    padding: 0rem;\n  }\n\n  #TransitTabs_TabContents {\n    margin: 0rem;\n    margin-top: 2rem !important;\n  }\n\n  #ReportSelector_Dropdown {\n    margin: auto;\n  }\n\n  #ReportSelector_Card {\n    padding: 1rem;\n  }\n\n  #ReportManager_Card {\n    padding: 0rem;\n    overflow-x: auto;\n    margin-top: 1rem;\n    padding: 1rem;\n  }\n\n  .hide-mobile {\n    display: none !important;\n  }\n\n  .tabsContainer {\n    margin: 0.5rem;\n  }\n\n  .tabContents {\n    margin: 0.5rem;\n  }\n\n  .stepLabel {\n    margin-left: 1rem;\n  }\n\n  .reportFilter {\n    margin-top: 1rem !important;\n    width: 84% !important;\n    text-align: initial;\n  }\n\n  .reportFilterTypography {\n    margin-top: 1rem !important;\n  }\n\n  #ReportSelector_FormControl {\n    margin: 0rem !important;\n  }\n\n  #ReportSelector_Intro {\n    margin-bottom: 0rem;\n  }\n\n  .cardPadding {\n    padding: 0rem;\n    overflow-x: auto;\n  }\n\n  .stepProgress {\n    margin-top: 1rem;\n  }\n\n  #ReportSteps_StepProgress {\n    margin-top: 2rem;\n  }\n\n  #StudentCriteria_GridStudentIdField {\n    margin-left: 0rem;\n    width: 98%;\n  }\n\n  #StudentCriteria_TextField {\n    margin-left: 0rem !important;\n  }\n\n  #StudentCriteria_Table>thead>tr>th>span {\n    font-size: 0.875rem;\n  }\n\n  .criteria_Button {\n    margin-top: 0.5rem !important;\n    margin-left: 0rem !important;\n  }\n\n  #ReportCriteria_RadioGroup>label>span {\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem;\n    margin-right: 0.5rem;\n    margin-left: 0rem;\n  }\n\n  #ReportCriteria_Continue {\n    margin-left: 1rem;\n    width: 95%;\n  }\n\n  .studentDataCriteria_Dropdown1 {\n    max-width: 305px;\n  }\n\n  .studentDataCriteria_Dropdown2 {\n    max-width: 256px;\n  }\n\n  #recurrence-information-popover>div {\n    left: 30px !important;\n  }\n}\n\n/* Override material-ui OutlinedInput dropdown which we can't figure out how to get to through PaperProps, like in What-If */\n\nul {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n/* here be hacks, cap'n. */\n.compare-control-dropdown div[role=\"button\"] {\n  padding-right: 0;\n}\n\n.compare-control-dropdown div {\n  font-size: 0.85rem;\n}\n\n.compare-control-dropdown svg {\n  width: 0.85em;\n  height: 0.85em;\n}\n\n#LoginForm_username-label[data-shrink=\"true\"] {\n  width: auto !important;\n}\n\n#LoginForm_password-label[data-shrink=\"true\"] {\n  width: auto !important;\n}\n\n#transit_freeText-label {\n  font-size: 0.95rem !important;\n}\n\n.react-time-picker__wrapper {\n  background-color: transparent !important;\n  min-width: unset !important;\n}\n\nlabel {\n  max-width: calc(100% - 3rem) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
